import React from "react";
import Approved from "../../asset/Approved.png";
import Unapproved from "../../asset/Unapproved.png";
import Illegal from "../../asset/Illegal.png";

import { FaCheck } from "react-icons/fa6";
import { BsExclamationCircle } from "react-icons/bs";
import { FiX } from "react-icons/fi";

import PrivateSocietyCard from "./PrivateSocietyCard";

const PrivateSocieties = () => {
  const cardData = [
    {
      name: "Approved Housing Societies",
      image: Approved,
      icon: <FaCheck />,
      link: "/ahs",
      bgColor: "#DEE9E4",
      tagColor: "#00643b",
      tagName: "Approved",
      class: "animate-slideRight",
    },
    {
      name: "Unapproved Housing Societies",
      image: Unapproved,
      icon: <BsExclamationCircle />,
      link: "/uhs",
      bgColor: "#DDEBF7",
      tagColor: "#008CFF",
      tagName: "Unapproved",
      class: "animate-slideLeft",
    },

    {
      name: "Illegal Housing Societies",
      image: Illegal,
      icon: <FiX />,
      link: "/ihs",
      bgColor: "#F1D1CE",
      tagColor: "#D80000",
      tagName: "Illegal",
      class: "animate-slideRight",
    },
  ];

  return (
    <div className="flex flex-col items-center pb-8 xl:pt-20 lg:pt-14 md:10 py-6 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%]">
      <span className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[1.8rem] font-bold text-center">
        Private Housing Societies
      </span>
      <span className="text-[#7A7A7A] text-center xl:text-[1.2rem] text-[1rem] lg:w-[70%] md:w-[85%] w-[100%] mx-auto">
        Public at large is advised to refrain from making any investment in
        illegal/fake/unapproved housing societies. Following is a list of
        housing societies.
      </span>
      <div className="flex flex-wrap justify-center items-stretch md:gap-8 gap-4 mt-12">
        {cardData.map((cd, i) => (
          <div key={i} className=" hover:scale-105 duration-500 transition-all">
            <PrivateSocietyCard key={i} cd={cd} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivateSocieties;
